// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.identify-body {
    background-color: var(--container-bg-color);
    height: 100%;
    display: flex;
    flex-direction: column;
}

span.identify-body-message {
    padding: 0.25em;
}

div.identify-body div.identify-results-tree {
    overflow-y: auto;
    flex: 1 1 50%;
    min-height: 0;
    background-color: var(--list-bg-color);
    border: 1px solid var(--border-color);
    padding: 0.25em;
    margin-bottom: 0.25em;
    font-size: small;
}

div.identify-results-tree-entry {
    display: flex;
}

div.identify-results-tree-entry > span:first-child {
    display: flex;
    align-items: center;
    cursor: pointer;
    flex: 1 1 auto;
}

span.identify-results-tree-entry-active {
    font-weight: bold;
}

div.identify-results-tree-entry span.identify-remove-result,
div.identify-results-tree-entry span.identify-export-result {
    margin: 0 0.25em;
    cursor: pointer;
    visibility: hidden;
    flex: 0 0 auto;
}

div.identify-results-tree-entry:hover > span.identify-remove-result,
div.identify-results-tree-entry:hover > span.identify-export-result {
    visibility: visible;
}

div.identify-results-tree-entries {
    padding: 0.25em 0.25em 0.25em 1em;
}

div.identify-body div.identify-flat-results-list {
    overflow: auto;
    flex: 1 1 auto;
}

div.identify-body div.identify-result-tree-frame {
    flex: 1 1 50%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border: 1px solid var(--border-color);
}

div.identify-body div.identify-result-frame {
    margin-bottom: 0.25em;
    border: 1px solid var(--border-color);
}

div.identify-body div.identify-result-frame:hover,
div.identify-body div.identify-result-tree-frame:hover {
    border: 1px solid var(--color-active);
}

div.identify-body .identify-result-title {
    background-color: var(--list-section-bg-color);
    color: var(--list-section-text-color);
    padding: 0.25em;
    font-weight: bold;
    flex: 0 0 auto;
    font-size: small;
    display: flex;
    align-items: center;
}

div.identify-body .identify-result-title > span:not(.icon) {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
}

div.identify-body .identify-result-title > span.icon {
    flex: 0 0 auto;
}

span.identify-result-checkbox {
    background-color: white;
}

div.identify-body .identify-result-title > span:not(:first-child) {
    margin-left: 0.5em;
}

div.identify-body .identify-result-title > span.icon:hover {
    color: var(--text-color-hover);
}

div.identify-body .identify-result-tree-frame > div.identify-result-container {
    overflow-y: auto;
}

div.identify-compare-results {
    display: grid;
    gap: 0.25em;
    grid-template-columns: repeat(auto-fit, minmax(calc(198px), 1fr));
    overflow: auto;
    flex: 1 1 auto;
}

div.identify-compare-results > div {
    overflow: auto;
}

div.identify-body .identify-result-box {
    border: 0;
    background-color: var(--list-bg-color);
    font-size: small;
    width: 100%;
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    margin: 0;
    overflow: auto;
}

div.identify-body table.attribute-list {
    width: 100%;
    table-layout: fixed;
}

div.identify-body table.attribute-list > tbody > tr:nth-child(even) {
    background-color: var(--list-item-bg-color-even);
}

div.identify-body table.attribute-list td {
    overflow: hidden;
    vertical-align: top;
    text-overflow: ellipsis;
}

div.identify-body table.attribute-list td:first-child {
    padding-left: 0.25em;
}

div.identify-body table.attribute-list td:last-child {
    padding-right: 0.25em;
}

div.identify-body table.attribute-list td.ellipsis {
    white-space: nowrap;
}

div.identify-body td.identify-attr-title {
    min-width: 10ch;
    width: 40%;
    padding-right: 1em;
}

div.identify-body td.identify-attr-value {
    width: 60%;
}

div.identify-body td.identify-attr-value > a > img {
    max-width: 100%;
}

div.identify-body div.identify-toolbar {
    background-color: var(--container-bg-color);
    margin-top: -0.25em;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    position: relative;
    border-top: 1px solid var(--border-color);
    padding-top: 0.25em;
}

span.identify-toolbar-spacer {
    flex: 1 1 auto;
}

div.identify-settings-menu {
    position: absolute;
    bottom: calc(100% - 0.25em);
    left: 0;
    border: 1px solid var(--border-color);
    background-color: var(--container-bg-color);
    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);
    z-index: 1;
    padding: 0.25em;
}

div.identify-settings-menu table td > div.controlgroup {
    width: 100%;
}

div.identify-body table.identify-attr-subtable {
    width: 100%;
}

div.identify-body table.identify-attr-subtable > tbody > tr:nth-child(even) {
    background-color: #F0F0F0;
}

div.identify-body td.identify-attr-spacer {
    height: 2px;
    background-color: var(--list-section-bg-color);
}

div.identify-body div.identify-results-tables {
    flex: 1 1 auto;
    overflow-y: auto;
}

div.identify-results-table-container {
    padding-bottom: 0.5em;
    border-bottom: 1px solid var(--border-color);
    margin-bottom: 0.5em;
}

div.identify-results-table-titlebar {
    display: flex;
    align-items: center;
    padding: 0.25em;
    gap: 1em;
}

div.identify-results-table-titlebar > span:nth-child(2) {
    flex: 1 1 auto;
    font-weight: bold;
    font-size: 110%;
}

div.identify-results-table-container > div.featurestable-frame {
    max-height: 15em;
    margin: 0.25em;
}
`, "",{"version":3,"sources":["webpack://./components/style/IdentifyViewer.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sCAAsC;IACtC,qCAAqC;IACrC,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iEAAiE;IACjE,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,sCAAsC;IACtC,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,OAAO;IACP,qCAAqC;IACrC,2CAA2C;IAC3C,8CAA8C;IAC9C,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;IAC5C,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":["div.identify-body {\n    background-color: var(--container-bg-color);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\nspan.identify-body-message {\n    padding: 0.25em;\n}\n\ndiv.identify-body div.identify-results-tree {\n    overflow-y: auto;\n    flex: 1 1 50%;\n    min-height: 0;\n    background-color: var(--list-bg-color);\n    border: 1px solid var(--border-color);\n    padding: 0.25em;\n    margin-bottom: 0.25em;\n    font-size: small;\n}\n\ndiv.identify-results-tree-entry {\n    display: flex;\n}\n\ndiv.identify-results-tree-entry > span:first-child {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    flex: 1 1 auto;\n}\n\nspan.identify-results-tree-entry-active {\n    font-weight: bold;\n}\n\ndiv.identify-results-tree-entry span.identify-remove-result,\ndiv.identify-results-tree-entry span.identify-export-result {\n    margin: 0 0.25em;\n    cursor: pointer;\n    visibility: hidden;\n    flex: 0 0 auto;\n}\n\ndiv.identify-results-tree-entry:hover > span.identify-remove-result,\ndiv.identify-results-tree-entry:hover > span.identify-export-result {\n    visibility: visible;\n}\n\ndiv.identify-results-tree-entries {\n    padding: 0.25em 0.25em 0.25em 1em;\n}\n\ndiv.identify-body div.identify-flat-results-list {\n    overflow: auto;\n    flex: 1 1 auto;\n}\n\ndiv.identify-body div.identify-result-tree-frame {\n    flex: 1 1 50%;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid var(--border-color);\n}\n\ndiv.identify-body div.identify-result-frame {\n    margin-bottom: 0.25em;\n    border: 1px solid var(--border-color);\n}\n\ndiv.identify-body div.identify-result-frame:hover,\ndiv.identify-body div.identify-result-tree-frame:hover {\n    border: 1px solid var(--color-active);\n}\n\ndiv.identify-body .identify-result-title {\n    background-color: var(--list-section-bg-color);\n    color: var(--list-section-text-color);\n    padding: 0.25em;\n    font-weight: bold;\n    flex: 0 0 auto;\n    font-size: small;\n    display: flex;\n    align-items: center;\n}\n\ndiv.identify-body .identify-result-title > span:not(.icon) {\n    flex: 1 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\ndiv.identify-body .identify-result-title > span.icon {\n    flex: 0 0 auto;\n}\n\nspan.identify-result-checkbox {\n    background-color: white;\n}\n\ndiv.identify-body .identify-result-title > span:not(:first-child) {\n    margin-left: 0.5em;\n}\n\ndiv.identify-body .identify-result-title > span.icon:hover {\n    color: var(--text-color-hover);\n}\n\ndiv.identify-body .identify-result-tree-frame > div.identify-result-container {\n    overflow-y: auto;\n}\n\ndiv.identify-compare-results {\n    display: grid;\n    gap: 0.25em;\n    grid-template-columns: repeat(auto-fit, minmax(calc(198px), 1fr));\n    overflow: auto;\n    flex: 1 1 auto;\n}\n\ndiv.identify-compare-results > div {\n    overflow: auto;\n}\n\ndiv.identify-body .identify-result-box {\n    border: 0;\n    background-color: var(--list-bg-color);\n    font-size: small;\n    width: 100%;\n    flex: 1 1 auto;\n    min-width: 0;\n    min-height: 0;\n    margin: 0;\n    overflow: auto;\n}\n\ndiv.identify-body table.attribute-list {\n    width: 100%;\n    table-layout: fixed;\n}\n\ndiv.identify-body table.attribute-list > tbody > tr:nth-child(even) {\n    background-color: var(--list-item-bg-color-even);\n}\n\ndiv.identify-body table.attribute-list td {\n    overflow: hidden;\n    vertical-align: top;\n    text-overflow: ellipsis;\n}\n\ndiv.identify-body table.attribute-list td:first-child {\n    padding-left: 0.25em;\n}\n\ndiv.identify-body table.attribute-list td:last-child {\n    padding-right: 0.25em;\n}\n\ndiv.identify-body table.attribute-list td.ellipsis {\n    white-space: nowrap;\n}\n\ndiv.identify-body td.identify-attr-title {\n    min-width: 10ch;\n    width: 40%;\n    padding-right: 1em;\n}\n\ndiv.identify-body td.identify-attr-value {\n    width: 60%;\n}\n\ndiv.identify-body td.identify-attr-value > a > img {\n    max-width: 100%;\n}\n\ndiv.identify-body div.identify-toolbar {\n    background-color: var(--container-bg-color);\n    margin-top: -0.25em;\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    position: relative;\n    border-top: 1px solid var(--border-color);\n    padding-top: 0.25em;\n}\n\nspan.identify-toolbar-spacer {\n    flex: 1 1 auto;\n}\n\ndiv.identify-settings-menu {\n    position: absolute;\n    bottom: calc(100% - 0.25em);\n    left: 0;\n    border: 1px solid var(--border-color);\n    background-color: var(--container-bg-color);\n    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);\n    z-index: 1;\n    padding: 0.25em;\n}\n\ndiv.identify-settings-menu table td > div.controlgroup {\n    width: 100%;\n}\n\ndiv.identify-body table.identify-attr-subtable {\n    width: 100%;\n}\n\ndiv.identify-body table.identify-attr-subtable > tbody > tr:nth-child(even) {\n    background-color: #F0F0F0;\n}\n\ndiv.identify-body td.identify-attr-spacer {\n    height: 2px;\n    background-color: var(--list-section-bg-color);\n}\n\ndiv.identify-body div.identify-results-tables {\n    flex: 1 1 auto;\n    overflow-y: auto;\n}\n\ndiv.identify-results-table-container {\n    padding-bottom: 0.5em;\n    border-bottom: 1px solid var(--border-color);\n    margin-bottom: 0.5em;\n}\n\ndiv.identify-results-table-titlebar {\n    display: flex;\n    align-items: center;\n    padding: 0.25em;\n    gap: 1em;\n}\n\ndiv.identify-results-table-titlebar > span:nth-child(2) {\n    flex: 1 1 auto;\n    font-weight: bold;\n    font-size: 110%;\n}\n\ndiv.identify-results-table-container > div.featurestable-frame {\n    max-height: 15em;\n    margin: 0.25em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
